import React from 'react';
import { TabPanel, Tabs, AuditNotesV2, useFeatureToggle, isAccess, isResourceAccess } from '@css-xp/base';
import SubscriptionTab from './products/subscription-tab';
import { CloudInvoiceTab } from './invoice-tab';
import { OrderHistoryTab } from './order-history-tab';
import { SubscriptionTabProps } from '../common-types';
import { SupportIssuesCloud } from './support-issues';
import { EntityWithNotes } from '@atlassian/cssxp-types-audit';
import { ENABLE_QUOTE } from '@atlassian/cssxp-utils-generic';
import { QuoteTab } from '@css-xp/quotes';
import { Permissions, Resources } from '@atlassian/cssxp-typescommon';

const CloudSiteTabs = (props: SubscriptionTabProps) => {
  const { parentSen, cloudSiteId, cloudSiteUrl } = props;
  const [isEnabled] = useFeatureToggle();
  return (
    <Tabs>
      <TabPanel label="All">
        <SubscriptionTab parentSen={parentSen} cloudSiteId={cloudSiteId} />
        <CloudInvoiceTab cloudId={cloudSiteId} />
        <OrderHistoryTab cloudId={cloudSiteId} />
        <SupportIssuesCloud params={{ cloudSiteId: cloudSiteId }} />
        <AuditNotesV2 id={cloudSiteId} entityName={EntityWithNotes.CloudSite} label={'Audit trail'} />
        {isEnabled(ENABLE_QUOTE) && isResourceAccess(Resources.QUOTE_ALL) && isAccess(Permissions.QUOTE_MANAGE) && (
          <QuoteTab query={cloudSiteUrl} label="Quotes" />
        )}
      </TabPanel>
      <TabPanel label="Subscriptions">
        <SubscriptionTab parentSen={parentSen} cloudSiteId={cloudSiteId} />
      </TabPanel>
      <TabPanel label="Invoices">
        <CloudInvoiceTab cloudId={cloudSiteId} />
      </TabPanel>
      <TabPanel label="Orders">
        <OrderHistoryTab cloudId={cloudSiteId} />
      </TabPanel>
      <TabPanel label="Support tickets">
        <SupportIssuesCloud params={{ cloudSiteId: cloudSiteId }} />
      </TabPanel>
      <TabPanel label="Audit trail">
        <AuditNotesV2 id={cloudSiteId} entityName={EntityWithNotes.CloudSite} label={'Audit trail'} />
      </TabPanel>
      {isEnabled(ENABLE_QUOTE) && isResourceAccess(Resources.QUOTE_ALL) && isAccess(Permissions.QUOTE_MANAGE) && (
        <TabPanel label="Quote">
          <QuoteTab query={cloudSiteUrl} label="Quotes" />
        </TabPanel>
      )}
    </Tabs>
  );
};

export default CloudSiteTabs;
